import script from "./new-footer.vue?vue&type=script&lang=js"
export * from "./new-footer.vue?vue&type=script&lang=js"

import "./new-footer.vue?vue&type=style&index=0&id=41b12f90&lang=scss"

const __exports__ = script;

export default __exports__